import React from "react";
import { t } from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";
import Config from "../../../config/main";
import moment from "moment";
import oddConverter from "@common/helpers/oddConverter";
import { BetStateViewEnum } from "../../../constants/enums/betState";
import { DepositModeEnum } from "../../../constants/enums/depositMode";

export default function ticketInTemplate() {
	let {
			terminalBalance,
			data: { enableTitoArgs, data },
			oddsFormat,
			depositMode,
		} = this.props,
		authData = JSON.parse(sessionStorage.getItem("balance")),
		balance = authData.session_balance;
	const { currency = "EUR" } = JSON.parse(sessionStorage.getItem("authData"));
	const { betshopid } = JSON.parse(sessionStorage.getItem("authData"));

	const renderBarcodeDetails = () => {
		if (data.betType === "BetBuilder") {
			return (
				<div className="bet-builder-details">
					{data.betBuilderDetails.descriptions.map(message => (
						<div key={message}>{message}</div>
					))}
				</div>
			);
		}

		return (
			<div className="ticket-b-info-w">
				<ul>
					<li>
						<p>{t("Selections")}</p>
					</li>
					<li>
						<p>{t("Event")}</p>
					</li>
					<li>
						<p>{t("Match Result")}</p>
					</li>
					<li>
						<p>{t("Date")}</p>
					</li>
					<li>
						<p>{t("Odds")}</p>
					</li>
					<li>
						<p>{t("Result")}</p>
					</li>
				</ul>
				{data.events &&
					data.events.event.map(event => {
						return (
							<ul key={event.selection_id} className="numbers-of-ticket">
								<li>
									<p>{event.event_name}</p>
								</li>
								<li>
									<p>{event.game_name}</p>
								</li>
								<li>
									<p className="match_result">
										{this.state.scores.length !== 0 &&
											Array.isArray(
												this.state.scores[0]
											) &&
											this.state.scores[0].map(game =>
												game.match_id &&
												game.match_id ===
													event.match_id
													? game.score
													: ""
											)}
									</p>
								</li>
								<li>
									<p>
										{moment(event.start_date_time).format(
											Config.main.dateTimeFormat
										)}
									</p>
								</li>
								<li>
									<p className="add-v-t">
										{oddConverter(
											event.coeficient === -1
												? t("SP")
												: event.coeficient
										)}
									</p>
								</li>
								<li>
									<p
										className={`status-view-b-t ${
											event.state === 0
												? "pending"
												: event.state === 3
												? "lost"
												: event.state === 2
												? "returned"
												: event.state === 6
												? "LoseReturn"
												: event.state === 1
												? "win-sp"
												: "win"
										}`}
									>
										{t(BetStateViewEnum[event.state])}
									</p>
								</li>
							</ul>
						);
					})}
			</div>
		);
	};

	return (
		<div className="ticket-results-view-p">
			<CountDownComponent second={30} />
			{Config.enableLogoOnPopups && <div className="mini-logo-container"></div>}
			<div
				className={`popup-message ${
					data.status === 1
						? "pending"
						: data.status === 3
						? "error"
						: data.status === 2
						? "returned"
						: data.status === -1
						? "rejected"
						: "accept"
				}`}
			>
				{
					// data.status === 1 &&
					<div className="show-cashout-info-t">
						<p>
							{t("Amount")}{" "}
							<i>
								{Config.main.currency[currency]}
								{data.betAmount}
							</i>
						</p>
						{data.possibleWin !== -1 ? (
							<p>
								{t("Price")}{" "}
								<i>{oddConverter(data.price, oddsFormat)}</i>
							</p>
						) : null}
						{data.possibleWin !== -1 ? (
							<p>
								{t("Possible win")}
								<i>
									{Config.main.currency[currency]}
									{data.possibleWin}
								</i>
							</p>
						) : null}
						{(data.possible_tax_amount || data.possible_tax_amount !== 0) && (
							<React.Fragment>
								<p>
									{t("Tax amount")}{" "}
									<i>
										{Config.main.currency[currency]}
										{data.possible_tax_amount}
									</i>
								</p>
								<p>
									{t("Estimated returns")}{" "}
									<i>
										{Config.main.currency[currency]}
										{(
											data.possibleWin -
											data.possible_tax_amount
										).toFixed(2)}
									</i>
								</p>
							</React.Fragment>
						)}
					</div>
				}
			</div>
			<h3 className="status-text">{t(data.statusText)}</h3>
			<h4>{t(data.competitionName)}</h4>
			{!Config.main.disableCashoutBet &&
				data.status === 1 &&
				data.cashout_amount &&
				data.events?.event?.length >= Config.main.minimumEarlyCashoutCount &&
				(!Config.diableBetPayForOtherBetshops ||
				Number(data.betshop_id) === Number(data.betshop_id) ? (
					<React.Fragment>
						<p className="popup-info-c">
							{t("Would you like to cashout")}
							<span>
								{" "}
								{Config.main.currency[currency]}
								{data.cashout_amount || 1}{" "}
							</span>{" "}
							{t("?")}{" "}
						</p>
						<div className="buttons-view-w-t">
							<ul>
								<li>
									<div className="separator-box-buttons-m">
										<button
											className="button-view-normal-m"
											onClick={this.cashoutDepositMoney()}
										>
											{t("cashout")}
										</button>
									</div>
								</li>
								<li>
									<div className="separator-box-buttons-m">
										<button
											className="button-view-normal-m trans-m"
											onClick={this.props.closePopup()}
										>
											{t("Cancel")}
										</button>
									</div>
								</li>
							</ul>
						</div>
					</React.Fragment>
				) : (
					<div className="wrong-betshopid">
						{t(`Please ask cashier to pay this ticket`)}
					</div>
				))}
			{(terminalBalance === null || terminalBalance === undefined ? balance : terminalBalance) +
				data.amount <=
				Config.main.balanceLimit &&
			!Config.main.disableTitoBet &&
			depositMode !== DepositModeEnum.Card &&
			data.status !== 1 &&
			data.status !== 3 ? (
				!Config.diableBetPayForOtherBetshops ||
				Number(data.betshop_id) === Number(data.betshop_id) ? (
					[
						enableTitoArgs && <p>{t("Would you like to deposit this amount?")}</p>,
						enableTitoArgs && (
							<div className="buttons-view-w-t">
								<ul>
									<li>
										<div className="separator-box-buttons-m">
											<button
												className="button-view-normal-m"
												onClick={
													!Config.dmsTicketInEnable ||
													!data.tax_amount
														? this.depositMoney()
														: this.props.openPopup(
																"dmsTicketIn",
																{
																	terminalBalance,
																	data,
																}
														  )
												}
											>
												{t("Add")}
											</button>
										</div>
									</li>
									<li>
										<div className="separator-box-buttons-m">
											<button
												className="button-view-normal-m trans-m"
												onClick={this.props.closePopup()}
											>
												{t("Cancel")}
											</button>
										</div>
									</li>
								</ul>
							</div>
						),
					]
				) : (
					<div className="wrong-betshopid">
						{t(`Please ask cashier to pay this ticket`)}
					</div>
				)
			) : null}
			{data?.predefined_multiple_id && (
				<div className="predifined-multiples-title">{t("Predifined multiples")}</div>
			)}
			{renderBarcodeDetails()}
			{data.events.event.some(item => item.state_name === t("NotResulted")) &&
			Config.enableCopyBetButton ? (
				<div className="separator-box-buttons-m copy-bet-button">
					<button className="button-view-normal-m" onClick={this.copyToBetSlip()}>
						{t("copy bet")}
					</button>
				</div>
			) : null}
		</div>
	);
}
